import { OrderStatus } from "../consts"

export default function ExternalPayments(order, offlineEnabled) {
  function get(uuid, orderObj = null) {
    if(orderObj) {
      for(let payment of orderObj.externalPayments) {
        if(payment.uuid === uuid) {
          return payment
        }
      }
      return null
    } else {
      for(let payment of order.order.externalPayments) {
        if(payment.uuid === uuid) {
          return payment
        }
      }
      return null
    }
  }
  
  function insertFromCloud(payment, orderObj = null) {
    if (payment == null) return null
    let exists = get(payment.uuid, orderObj)
    if (exists == null) {
      if (orderObj) {
        orderObj.externalPayments.push(payment)
      } else {
        order.order.externalPayments.push(payment)
      }
      return payment
    } else {
      return null
    }
  }

  function set(payment, cloud = false) {
    let existing = get(payment.uuid)
    if(existing) return 0
    payment.offline = (!cloud && offlineEnabled)
    //order.order.externalPayments.push(payment)
    order.addUpdate({ externalPayments: { [payment.uuid]: payment } })
    if(!cloud && offlineEnabled) {
      order.statuses.addStatus(OrderStatus.ORDER_PAYMENT_EXTERNAL, payment.sysUserUUID, { uuid: payment.uuid })
    }
    return 1
  }

  function calculateTotal() {
    let total = 0
    //console.log("order.order.externalPayments", order.order.externalPayments)
    for(let payment of (order.order.externalPayments || [])) {
      //console.log({payment})
      total += +payment.amount
    }
    return total
  }

  function calculateDeliveryTotal() {
    let amount = 0
    for(let payment of (order.order.externalPayments || [])) {
      //console.log("calculateDeliveryTotal", {payment})
      amount += +payment?.delivery
    }
    return {
      amount
    }
  }

  function calculateItemTotal(iid) {
    let amount = 0
    let count = 0
    for(let payment of (order.order.externalPayments || [])) {
      amount += +payment?.items?.[iid]?.amt
      count += (payment?.items?.[iid]?.cnt || 0)
    }
    return {
      amount,
      count
    }
  }

  return {
    get,
    set,
    insertFromCloud,
    calculateTotal,
    calculateItemTotal,
    calculateDeliveryTotal
  }
}